module.exports = __webpack_public_path__ + "static/sustainpr-c4b0763cd6b3148cf68ed9cccd75ba85.png";